<template>
    <div class="qty_options">
        <span class="qty_options__option" @click="changeQty('-')" v-if="selectedQty > 1 && selectedQty > minimumQty">
            <svg version="1.1" width="10px" height="10px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 42 42" style="enable-background:new 0 0 42 42;" xml:space="preserve"><rect y="19" width="42" height="4" stroke="white" stroke-width="4px" /></svg>
        </span>
        <span class="qty_options__option qty_options__option--disabled" v-else>
            <svg version="1.1" width="10px" height="10px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 42 42" style="enable-background:new 0 0 42 42;" xml:space="preserve"><rect y="19" width="42" height="4" stroke="white" stroke-width="4px" /></svg>
        </span>
        <span class="qty_options__number" v-html="selectedQty"></span>
        <span class="qty_options__option" @click="changeQty('+')" v-if="available > 0 && selectedQty < maximumQty">
            <svg version="1.1" width="10px" height="10px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 42 42" style="enable-background:new 0 0 42 42;" xml:space="preserve"><polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " stroke="white" stroke-width="4px" /></svg>
        </span>
        <span class="qty_options__option qty_options__option--disabled" v-else>
            <svg version="1.1" width="10px" height="10px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 42 42" style="enable-background:new 0 0 42 42;" xml:space="preserve"><polygon points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " stroke="white" stroke-width="4px" /></svg>
        </span>
    </div>
</template>

<script>
export default {
    name: 'cart-item-qty',
    props: [
        'qty',
        'minQty',
        'maxQty',
        'availability',
        'index',
    ],
    data(){
        return {
            selectedQty: 1,
            minimumQty: 1,
            maximumQty: 10000,
            available: 10,
            busy: false,
            timer: null
        }
    },
    mounted() {
        this.selectedQty = this.qty;
        if (this.minQty) {
            this.minimumQty = this.minQty;
        }
        if (this.maxQty) {
            this.maximumQty = this.maxQty;
        }
        this.available = this.availability;
    },
    methods: {
        changeQty(operator) {
            var vm = this;
            clearTimeout(this.timer);

            if (operator == '+') {
                this.selectedQty++;
                this.available--;
            } else {
                this.selectedQty--;
                this.available++;
            }

            this.timer = setTimeout(() => {
                this.busy = true;
                axios.post('/basket/change-qty', {
                    qty: this.selectedQty,
                    index: this.index
                }).then(() => {
                    window.location.reload();
                }).catch(function(error) {
                    let errorMessage = 'There was a problem updating your ticket quantity';
                    if (error.response && error.response.data && error.response.data.errors.qty) {
                        errorMessage = error.response.data.errors.qty;
                    }
                    vm.$toasted.show(errorMessage, {
                        theme: "bubble",
                        type: 'error',
                        position: "top-center",
                        duration: 3000
                    });
                    window.location.reload();
                })
            }, 750);
        }
    }
}
</script>

<style lang="scss" scoped>
.qty_options {
    min-width: 90px;
    font-size: 0;
    > * {
        display: inline-block;
        vertical-align: middle;
        font-size: 1rem;
    }
    &__number {
        padding: 0 10px;
    }
    &__option {
        padding: 8px 8px;
        background: darken(#efefef, 5%);
        border-radius: 50%;
        transition: all 0.2s ease-in-out;
        &:hover {
            background: darken(#efefef, 50%);
            svg path,
            svg rect,
            svg polygon {
                fill: white;
            }
        }
        &--disabled {
            cursor: not-allowed;
            opacity: 0.4;
            &:hover {
                background: darken(#efefef, 5%);
                svg path,
                svg rect,
                svg polygon {
                    fill: black;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Basket/Cart-item-qty.vue